// @ts-check
import React from 'react';
import imgSrc from './conditional_icon.svg';

const HasConditionalIndicator = () => (
  <span>
    <img src={imgSrc} alt="has conditional" />
  </span>
);

export default HasConditionalIndicator;
